module.exports = __webpack_public_path__ + "img/tgjs.5e87281a.png";